module.exports = __webpack_public_path__ + "img/cast.55d85bd4.png";